"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _AbstractRestriction_id, _AbstractRestriction_parentNode, _AbstractRestriction_type, _AbstractRestriction_viewport, _AbstractRestriction_visualizationNode, _AbstractRestriction_rotation, _AbstractRestriction_showVisualization;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractRestriction = void 0;
const THREE = __importStar(require("three"));
const viewer_shared_node_tree_1 = require("@shapediver/viewer.shared.node-tree");
const viewer_rendering_engine_rendering_engine_threejs_1 = require("@shapediver/viewer.rendering-engine.rendering-engine-threejs");
const gl_matrix_1 = require("gl-matrix");
class AbstractRestriction {
    // #endregion Properties (12)
    // #region Constructors (1)
    constructor(viewport, parentNode, id, properties) {
        // #region Properties (12)
        _AbstractRestriction_id.set(this, void 0);
        _AbstractRestriction_parentNode.set(this, void 0);
        _AbstractRestriction_type.set(this, void 0);
        _AbstractRestriction_viewport.set(this, void 0);
        _AbstractRestriction_visualizationNode.set(this, new viewer_shared_node_tree_1.TreeNode('RestrictionVisualizationNode'));
        _AbstractRestriction_rotation.set(this, void 0);
        _AbstractRestriction_showVisualization.set(this, false);
        this._enabled = true;
        this._enabledEditable = true;
        this._priority = -1;
        this._snapRestrictions = {};
        __classPrivateFieldSet(this, _AbstractRestriction_parentNode, parentNode, "f");
        __classPrivateFieldSet(this, _AbstractRestriction_viewport, viewport, "f");
        __classPrivateFieldSet(this, _AbstractRestriction_id, id, "f");
        __classPrivateFieldSet(this, _AbstractRestriction_type, properties.type, "f");
        __classPrivateFieldSet(this, _AbstractRestriction_rotation, properties.rotation || { axis: gl_matrix_1.vec3.fromValues(0, 0, 1), angle: 0 }, "f");
        this.createGridHelperObject();
    }
    // #endregion Constructors (1)
    // #region Public Getters And Setters (11)
    get enabled() {
        return this._enabled;
    }
    set enabled(value) {
        if (this._enabledEditable === false)
            return;
        this._enabled = value;
        this.visibilityChanged(this._object3D.visible);
    }
    get id() {
        return __classPrivateFieldGet(this, _AbstractRestriction_id, "f");
    }
    get priority() {
        return this._priority;
    }
    set priority(value) {
        this._priority = value;
    }
    get rotation() {
        return __classPrivateFieldGet(this, _AbstractRestriction_rotation, "f");
    }
    set rotation(value) {
        __classPrivateFieldSet(this, _AbstractRestriction_rotation, value, "f");
    }
    get showVisualization() {
        return __classPrivateFieldGet(this, _AbstractRestriction_showVisualization, "f");
    }
    set showVisualization(value) {
        __classPrivateFieldSet(this, _AbstractRestriction_showVisualization, value, "f");
        this._object3D.visible = value;
        this.visibilityChanged(this._object3D.visible);
    }
    get snapRestrictions() {
        return this._snapRestrictions;
    }
    get type() {
        return __classPrivateFieldGet(this, _AbstractRestriction_type, "f");
    }
    // #endregion Public Getters And Setters (11)
    // #region Public Methods (1)
    removeVisualization() {
        __classPrivateFieldGet(this, _AbstractRestriction_parentNode, "f").removeChild(__classPrivateFieldGet(this, _AbstractRestriction_visualizationNode, "f"));
        __classPrivateFieldGet(this, _AbstractRestriction_parentNode, "f").updateVersion(false, false);
        __classPrivateFieldGet(this, _AbstractRestriction_viewport, "f").updateNode(__classPrivateFieldGet(this, _AbstractRestriction_parentNode, "f"));
    }
    // #endregion Protected Abstract Methods (1)
    // #region Private Methods (1)
    createGridHelperObject() {
        this._object3D = new THREE.Object3D();
        this._object3D.visible = false;
        const node = new viewer_shared_node_tree_1.TreeNode('ThreeJsDataNode');
        const data = new viewer_rendering_engine_rendering_engine_threejs_1.ThreejsData(this._object3D);
        node.addData(data);
        __classPrivateFieldGet(this, _AbstractRestriction_visualizationNode, "f").addChild(node);
        __classPrivateFieldGet(this, _AbstractRestriction_visualizationNode, "f").updateVersion();
        __classPrivateFieldGet(this, _AbstractRestriction_parentNode, "f").addChild(__classPrivateFieldGet(this, _AbstractRestriction_visualizationNode, "f"));
        __classPrivateFieldGet(this, _AbstractRestriction_parentNode, "f").updateVersion(false, false);
        __classPrivateFieldGet(this, _AbstractRestriction_viewport, "f").updateNode(__classPrivateFieldGet(this, _AbstractRestriction_parentNode, "f"));
    }
}
exports.AbstractRestriction = AbstractRestriction;
_AbstractRestriction_id = new WeakMap(), _AbstractRestriction_parentNode = new WeakMap(), _AbstractRestriction_type = new WeakMap(), _AbstractRestriction_viewport = new WeakMap(), _AbstractRestriction_visualizationNode = new WeakMap(), _AbstractRestriction_rotation = new WeakMap(), _AbstractRestriction_showVisualization = new WeakMap();
//# sourceMappingURL=AbstractRestriction.js.map